import { css } from 'styled-components';
import token from 'styled-token';
import { StyledDropdownIcon } from '../../components/DropdownIcon/DropdownIcon.styles';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardActionAreaMixin */
/** @method */
export var PropertyCardActionAreaMixin = function PropertyCardActionAreaMixin(props) {
  return token({
    columnGap: 'PropertyCard.action.columnGap',
    iconSize: 'PropertyCard.action.icon.size'
  }, function (_ref) {
    var columnGap = _ref.columnGap,
      iconSize = _ref.iconSize;
    return css(["grid-area:actions;display:grid;grid-auto-flow:column;grid-column-gap:", ";justify-content:end;", " > svg{width:", "px;height:", "px;}"], columnGap ? columnGap + "px" : spaceMixin('sm')(props), StyledDropdownIcon, iconSize, iconSize);
  });
};